/**
 * Trade-in related type definitions and enums
 *
 * TEMPORARY FIX: These types support client-side trade-in mapping which is temporary.
 * In follow-up PRs, this logic will be moved to the server side for better
 * consistency and maintainability.
 */
import type { DXGSaleVehicle } from '@makemydeal/dr-platform-types';

export enum TRADE_OWNERSHIP_TYPE {
    PURCHASE = 'Purchase',
    LEASE = 'Lease'
}

export enum TradeVehicleCodeType {
    ALG = 'AlgCode',
    CHROME = 'ChromeStyleId'
}

export type VehicleCode = {
    codeType: TradeVehicleCodeType;
    makeCode?: number;
    styleCode?: number;
    chromeStyleId?: number;
};

export type VehicleOption = {
    cost: number;
    details: {
        description: string;
        name: string;
        oemOptionCode: string;
    };
    price: number;
    optionType: string;
};

export type TradeInVehicle = DXGSaleVehicle & {
    classification?: string;
    condition?: string;
    isLeaseTrade?: boolean;
    odometer?: number;
    installedOptions?: VehicleOption[];
    vehicleCodes?: VehicleCode[];
};

export type TradeIn = {
    isBuyerRegisteredOwner?: boolean;
    isSellingVehicleRegisteredInSameState?: boolean;
    isTradeIncluded?: boolean;
    appliedTradeAllowance?: number;
    tradeAllowance?: number;
    tradePayoffDetails?: { tradePayoffAmount?: number };
    tradeValuation?: {
        acquisitionOffer?: { source?: string };
        actualCashValue?: number;
    };
    tradeVehicle?: TradeInVehicle;
};
